import React, { useState, useRef } from "react";
import CareTeamCard from "./common/CareTeamCard";
import EntityHeader from "./common/EntityHeader";
import {
  formatDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";
import CareTeamModal from "./common/CareTeamModal";
import moment from "moment";

function CareTeamEntity({
  selectedProgram,
  careTeam,
  showExpired,
  updateCareTeam,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialData, setInitialData] = useState();

  const showModal = (careTeamMember) => {
    let contactInfo = {};

    if (getFieldName(careTeamMember.ccx_membertype) === "Contact") {
      contactInfo = {
        FirstName: careTeamMember["con.firstlast"].split(" ")[0],
        LastName: careTeamMember["con.firstlast"].split(" ")[1],
        Email: careTeamMember["con.emailaddress1"],
        MobilePhone: careTeamMember["con.mobilephone"],
        Gender: careTeamMember["con.sor_preferredgender"],
        DateOfBirth: careTeamMember["con.birthdate"],
        Type: careTeamMember["con.ccx_contacttype"],
      };
    }

    const obj = {
      ccx_careteamid: careTeamMember.ccx_careteamid,
      ccx_membertype: getFieldText(careTeamMember.ccx_membertype),
      ccx_memberid: getFieldText(careTeamMember.ccx_memberid),
      ProviderName: getFieldName(careTeamMember.ccx_memberid),
      sor_providerrole:
        careTeamMember.sor_providerrole &&
        getFieldText(careTeamMember.sor_providerrole),
      ccx_primarymember: getFieldText(careTeamMember.ccx_primarymember),
      ccx_contact: getFieldText(careTeamMember.ccx_contact),
      ContactName: getFieldName(careTeamMember.ccx_contact),
      sor_contactrole: getFieldText(careTeamMember.sor_contactrole),
      sor_contactrelationshipother: careTeamMember.sor_contactrelationshipother,
      sor_emergencycontact:
        getFieldText(careTeamMember.sor_emergencycontact) || "0",
      ccx_effdate:
        careTeamMember.ccx_effdate &&
        formatDate(getFieldText(careTeamMember.ccx_effdate)),
      ccx_expdate:
        careTeamMember.ccx_expdate &&
        formatDate(getFieldText(careTeamMember.ccx_expdate)),
      ccx_expirationreason: careTeamMember.ccx_expirationreason,
    };
    setInitialData(obj);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const addNew = () => {
    setInitialData(undefined);
    setIsOpen(true);
  };

  return (
    <>
      {isOpen ? (
        <CareTeamModal
          isOpen={true}
          addNew={addNew}
          hideModal={hideModal}
          initialData={initialData}
          clientProgram={selectedProgram}
          existingCareTeam={careTeam}
          updateCareTeam={updateCareTeam}
        ></CareTeamModal>
      ) : null}
      <EntityHeader
        title={"Care Team Members"}
        add={addNew}
        {...rest}
        body={
          careTeam
            ? careTeam
                .filter(
                  (ct) =>
                    getFieldText(ct.ccx_clientprogram) ===
                    selectedProgram.ccx_client_programid
                )
                .map((ct) => (
                  <div
                    className={
                      ct.ccx_expdate !== undefined && !showExpired
                        ? "d-none p-2"
                        : "d-block p-2"
                    }
                    key={ct.ccx_careteamid}
                  >
                    <CareTeamCard
                      onEdit={() => showModal(ct)}
                      teamMember={ct}
                    />
                  </div>
                ))
            : "No Care Team Members"
        }
      ></EntityHeader>
      <div className="row row-cols-1">{}</div>
    </>
  );
}

export default CareTeamEntity;
